import React, { useState, useEffect, useRef } from "react";
import Pagination from "react-js-pagination";
import {
  Box,
  HStack,
  Text,
  Table,
  Thead,
  Tbody,
  Th,
  Tr,
  Td,
  TableContainer,
  Button,
  useDisclosure,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Input,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Checkbox,
  Flex,
  Icon,
} from "@chakra-ui/react";
import { LuChevronDown } from "react-icons/lu";
import { fetchWrapper } from "../../helpers";
import PageLoader from '../../components/Loader/PageLoader';
import Papa from "papaparse";
import { toast } from "react-toastify";
import axios from "axios";
import { useParams } from "react-router-dom";

function List() {
  const inputRef = useRef(null);
  const [list, setList] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [listCount, setListCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [activeType, setActiveType] = useState("sms"); // Default to "sms"
  const [country, setCountry] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");

  const [operator, setOperator] = useState([]);
  const [channelOptions, setChannelOptions] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState("");

  const [searchCountry, setSearchCountry] = useState("");
  const [searchOperator, setSearchOperator] = useState("");

  const { id } = useParams();
  const [type, setType] = useState("");






  const [channels, setChannels] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [newPrice, setNewPrice] = useState('');
  const [modalType, setModalType] = useState('price');


  const handleOpenModal = (channelId, channelData, modalType) => {
    setSelectedChannel({ id: channelId, ...channelData });

    if (modalType === 'api_charges') {
      setModalType('channels');
      // Initialize selected channels from existing data or empty array
      const existingChannels = channelData?.channel_in_use?.filter((ch) => ch.allow === true).map(ch => ch.channel_id) || [];


      setSelectedChannel(existingChannels);
    } else {
      setModalType('price');
      setNewPrice(channelData.price ? channelData.price.toString() : '');
    }

    setIsModalOpen(true);
  };




  const handleSavePrice = async () => {
    if (selectedChannel) {
      try {
        let updatedChannels = { ...channels };

        if (modalType === 'channels') {
          // Update only the channel_in_use within api_charges
          updatedChannels = {
            ...channels,
            api_charges: {
              ...channels.api_charges,
              channel_in_use: channelOptions.map(channel => ({
                channel_id: channel.id,
                allow: selectedChannel.includes(channel.id)
              })),
              update_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
            }
          };
        } else {
          // For price updates
          updatedChannels = {
            ...channels,
            [selectedChannel.id]: {
              ...channels[selectedChannel.id],
              price: parseFloat(newPrice),
              update_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
            }
          };
        }

        const url = `${process.env.REACT_APP_API_URL}/price_channel/update`;
        const updatedData = {
          id: +id,
          other_channel_pricing: JSON.stringify(updatedChannels)
        };


        await fetchWrapper.post(url, updatedData);
        await OtherChannelsList(); // Refresh the data

        toast.success("Updated successfully");
        setIsModalOpen(false);
        setSelectedChannel(null);
        setNewPrice('');
        setSelectedChannel([]);
      } catch (error) {
        console.error("Error updating:", error);
        toast.error("Failed to update");
      }
    }
  };


  useEffect(() => {
    if (activeType === "other_channels") {
      OtherChannelsList()
      ChannelsList()

    } else {
      CountryList();
      OperatorList();
      loadList(activeType, selectedCountry.id, selectedOperator.id);
    }

  }, [activePage, selectedCountry, selectedOperator, activeType]);

  const loadList = async (type = "sms", countryId = "", operatorId = "") => {
    setLoading(true); // Show the loading spinner

    try {
      const url = `${process.env.REACT_APP_API_URL}/price/list?price_channel_id=${id}&page=${activePage}&country_id=${countryId}&operator_id=${operatorId}&type=${type}`;
      const data = await fetchWrapper.get(url);

      // Update the list and pagination state
      setList(data?.rows || []);
      setListCount(data?.count || 0);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }

    setLoading(false); // Hide the loading spinner
  };

  // Handle Tab Change
  const handleTabChange = (type) => {
    setActiveType(type); // Update the active type (sms or whatsapp)
    if (type !== "other_channels") {

      loadList(type, selectedCountry.id, selectedOperator.id); // Fetch the data for the selected type
    }
  };

  const ChannelsList = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/channel/list`;
      const data = await fetchWrapper.get(url);
      let transformedData = data.data.map((item) => ({
        label: item?.name,
        value: item?.name,
        ...item
      }));
      setChannelOptions([...transformedData]);
    } catch (error) {
      console.error('Error fetching channels:', error);
    }
  };




  const CountryList = async () => {
    const url = `${process.env.REACT_APP_API_URL}/country/list`;
    const data = await fetchWrapper.get(url);
    setCountry(data.rows);
  };
  const OtherChannelsList = async () => {
    const url = `${process.env.REACT_APP_API_URL}/other-channel-price?id=${id}`;
    const data = await fetchWrapper.get(url);
    // setCountry(data.rows);
    let channelList = !data?.other_channel_pricing ? {
      "in_app": { "price": null, "update_at": null, "name": "In App", "id": "in_app" },
      "push_notification": { "price": null, "update_at": null, "name": "Push Notification", "id": "push_notification" },
      "email": { "price": null, "update_at": null, "name": "Email", "id": "email" },
      "api_charges": { "price": null, "update_at": null, "channel_in_use": null, "name": "API Charges", "id": "api_charges" }
      // "api_charges":{"price":20,"update_at":"2025-01-21 17:19","channel_in_use":[{channel_id:1,allow:true},{channel_id:2,allow:false},{channel_id:2,allow:true}]}
    } : JSON.parse(data?.other_channel_pricing || "{}");
    setChannels(channelList);

  };



  const OperatorList = async () => {
    const url = `${process.env.REACT_APP_API_URL}/operator/list`;
    const data = await fetchWrapper.get(url);
    setOperator(data.rows);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", type);
      formData.append("price_channel_id", id); // Pass price_channel_id

      const url = `${process.env.REACT_APP_API_URL}/csv`;

      axios
        .post(url, formData)
        .then((response) => {
          toast.success(response.data.message);
          loadList(activeType);
        })
        .catch((error) => {
          toast.error(`Failed to upload file: ${error.message}`);
        });

      if (inputRef.current) {
        inputRef.current.value = null;
      }
    }
  };

  const handleClick = (type) => {
    setType(type);
    inputRef.current.click();
  };

  const onChangePaginate = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleSelect = (type, rs) => {
    const { id, name } = rs;
    if (type === "country") {
      setSelectedCountry({ id, name });
    } else if (type === "operator") {
      setSelectedOperator({ id, name });
    }
  };

  const meSearch = (type, e) => {
    if (type === "country") {
      setSearchCountry(e.target.value);
    }
    if (type === "operator") {
      setSearchOperator(e.target.value);
    }
  };

  const filteredCountries = country?.filter((rs) =>
    rs.name.toLowerCase().includes(searchCountry.toLowerCase())
  );

  const filteredOperator = operator?.filter((rs) =>
    rs.name.toLowerCase().includes(searchOperator.toLowerCase())
  );

  const meCsv = async (type) => {
    try {
      const fetchUrl = `${process.env.REACT_APP_API_URL}/price/list?type=${type}&price_channel_id=${id}`;
      const data = await fetchWrapper.get(fetchUrl);
      const listed = data.rows;

      if (!listed.length) {
        toast.error("No data available to download");
        return;
      }

      const csvData = generateCsvData(listed, type);
      const csv = Papa.unparse(csvData);

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "price_list.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("File downloaded successfully");
    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to download file");
    }
  };

  // Separated mapping logic for clarity
  const generateCsvData = (data, type) => {
    if (type === "whatsapp") {
      return data.map((rs) => ({
        Country: rs?.Country?.name || "",
        "OTP Cost": rs.otp_cost || "",
        "Utility Cost": rs.utility_cost || "",
        "Price Channel ID": rs.price_channel_id || "",
        "Status ID": rs.status_id || "",
        "Created At": rs.created_at || "",
        "Updated At": rs.updated_at || "",
      }));
    } else {
      return data.map((rs) => ({
        Country: rs?.Operator?.Country?.name || "",
        Operator: rs?.Operator?.name || "",
        MCC: rs?.Operator?.mcc || "",
        MNC: rs?.Operator?.mnc || "",
        Prefix: rs?.Operator?.prefix || "",
        "Sender ID":
          rs?.Operator?.sender_id === 0 ? "Default" : rs?.Operator?.sender_id,
        "SMS Cost": rs.sms_cost || "",
        "WhatsApp Cost": rs.whatsapp_cost || "",
      }));
    }
  };


  const onModalClose = () => {
    setIsModalOpen(false);
  }

  // Add this function to handle checkbox changes
  // Update handleCheckboxChange function
  const handleCheckboxChange = (channelId) => {
    setSelectedChannel(prev => {
      if (prev.includes(channelId)) {
        return prev.filter(id => id !== channelId);
      } else {
        return [...prev, channelId];
      }
    });
  };



  return (
    <>
      <PageLoader isLoading={loading} />
      <input
        type="file"
        onChange={handleFileChange}
        accept=".csv"
        ref={inputRef}
        style={{ display: "none" }}
      />
      <div >
        <Tabs
          className="customer_tabs_section tabs_fit_content"
          onChange={(index) => {
            const types = ["sms", "whatsapp", "ivr", "other_channels"];
            const selectedType = types[index];
            setActiveType(selectedType); // Update the active type
            handleTabChange(selectedType);
          }}
        >
          <TabList className="customer_tabs_head_section">
            <Tab>SMS Cost</Tab>
            <Tab>WhatsApp Cost</Tab>
            <Tab>Voice (IVR)</Tab>
            <Tab>Other Channels</Tab>
          </TabList>

          <TabPanels>
            <TabPanel className="customer_transaction_panel">
              {/* Table and filters for SMS Cost */}
              <HStack justifyContent="space-between" mb="25px">
                <Box>
                  <Text fontSize="32px" fontWeight="300" color="#000000">
                    SMS Cost Price List
                  </Text>
                </Box>
                <Box>
                  <HStack>
                    <Box>
                      <Menu>
                        <MenuButton
                          as={Button}
                          rightIcon={<Icon as={LuChevronDown} />}
                          className="menu-filter"
                        >
                          {selectedCountry.name || "Country"}
                        </MenuButton>
                        <MenuList>
                          <Box p="10px">
                            <Input
                              placeholder="Search country"
                              value={searchCountry}
                              onChange={(e) => meSearch("country", e)}
                            />
                          </Box>
                          <MenuItem onClick={() => handleSelect("country", "")}>
                            All Show
                          </MenuItem>
                          {filteredCountries?.slice(0, 10).map((rs, index) => (
                            <MenuItem
                              key={index}
                              onClick={() => handleSelect("country", rs)}
                            >
                              {rs.name}
                            </MenuItem>
                          ))}
                        </MenuList>
                      </Menu>
                    </Box>
                    <Box>
                      <Menu>
                        <MenuButton
                          as={Button}
                          rightIcon={<Icon as={LuChevronDown} />}
                          className="menu-filter"
                        >
                          {selectedOperator.name || "Operator"}
                        </MenuButton>
                        <MenuList>
                          <Box p="10px">
                            <Input
                              placeholder="Search operator"
                              value={searchOperator}
                              onChange={(e) => meSearch("operator", e)}
                            />
                          </Box>
                          <MenuItem onClick={() => handleSelect("operator", "")}>
                            All Show
                          </MenuItem>
                          {filteredOperator?.slice(0, 10).map((rs, index) => (
                            <MenuItem
                              key={index}
                              onClick={() => handleSelect("operator", rs)}
                            >
                              {rs.name}
                            </MenuItem>
                          ))}
                        </MenuList>
                      </Menu>
                    </Box>
                    <Box>
                      <Button className="filter-button" onClick={() => meCsv('sms')}>
                        Download Price List
                      </Button>
                    </Box>
                    <Box>
                      <Menu>
                        <MenuButton as={Button} className="menu-filter-button" onClick={() => handleClick("sms")}>
                          Import Updated Price List
                        </MenuButton>
                      </Menu>
                    </Box>
                  </HStack>
                </Box>
              </HStack>

              <div className="table_section">
                <TableContainer width="100%">
                  <Table
                    variant="simple"
                    width="100%"
                    borderWidth="1px"
                    borderColor="#CCCCCC"
                    borderStyle="solid"
                  >
                    <Thead>
                      <Tr>
                        <Th>Country</Th>
                        <Th>Operator</Th>
                        <Th>MCC</Th>
                        <Th>MNC</Th>
                        <Th>Prefix</Th>
                        <Th>Sender ID</Th>
                        <Th>SMS Cost</Th>
                        <Th>Last Updated</Th>
                      </Tr>
                    </Thead>

                    <Tbody fontSize="14px">
                      {list.map((rs, index) => (
                        <Tr key={index}>
                          <Td>{rs?.Operator?.Country?.name}</Td>
                          <Td>{rs?.Operator?.name}</Td>
                          <Td>{rs?.Operator?.mcc}</Td>
                          <Td>{rs?.Operator?.mnc}</Td>
                          <Td>{rs?.Operator?.prefix}</Td>
                          <Td>
                            {rs?.Operator?.sender_id === 0
                              ? "Default"
                              : rs?.Operator?.sender_id}
                          </Td>
                          <Td>{rs.sms_cost}</Td>
                          <Td>27/08/2024</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                  <Flex justifyContent="center" alignItems="center" >
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={100}
                      totalItemsCount={listCount}
                      pageRangeDisplayed={5}
                      onChange={onChangePaginate}
                      innerClass="pagination"
                      itemClass="page-item"
                      activeLinkClass="page-link active"
                      linkClass="page-link"
                      prevPageText="Previous"
                      nextPageText="Next"
                    />
                  </Flex>
                </TableContainer>
              </div>
            </TabPanel>

            {/* Add other tab panels for WhatsApp Cost, IVR, etc., here */}
            <TabPanel className="customer_transaction_panel">
              {/* Table and filters for WhatsApp Cost */}
              <HStack justifyContent="space-between" mb="25px">
                <Box>
                  <Text fontSize="32px" fontWeight="300" color="#000000">
                    WhatsApp Cost Price List
                  </Text>
                </Box>
                <Box>
                  <HStack>
                    <Box>
                      <Menu>
                        <MenuButton
                          as={Button}
                          rightIcon={<Icon as={LuChevronDown} />}
                          className="menu-filter"
                        >
                          {selectedCountry.name || "Country"}
                        </MenuButton>
                        <MenuList>
                          <Box p="10px">
                            <Input
                              placeholder="Search country"
                              value={searchCountry}
                              onChange={(e) => meSearch("country", e)}
                            />
                          </Box>
                          <MenuItem onClick={() => handleSelect("country", "")}>
                            All Show
                          </MenuItem>
                          {filteredCountries?.slice(0, 10).map((rs, index) => (
                            <MenuItem
                              key={index}
                              onClick={() => handleSelect("country", rs)}
                            >
                              {rs.name}
                            </MenuItem>
                          ))}
                        </MenuList>
                      </Menu>
                    </Box>
                    <Box>
                      <Button className="filter-button" onClick={() => meCsv("whatsapp")}>
                        Download Price List
                      </Button>
                    </Box>
                    <Box>
                      <Menu>
                        <MenuButton as={Button} className="menu-filter-button" onClick={() => handleClick("whatsapp")}>
                          Import Updated Price List
                        </MenuButton>
                      </Menu>
                    </Box>
                  </HStack>
                </Box>
              </HStack>

              <div className="table_section">
                <TableContainer width="100%">
                  <Table
                    variant="simple"
                    width="100%"
                    borderWidth="1px"
                    borderColor="#CCCCCC"
                    borderStyle="solid"
                  >
                    <Thead>
                      <Tr>
                        <Th>Country</Th>
                        <Th>OTP Cost</Th>
                        <Th>Utility Cost</Th>
                        <Th>Sender Id</Th>
                        <Th>Last Updated</Th>
                      </Tr>
                    </Thead>

                    <Tbody fontSize="14px">
                      {list.map((rs, index) => (
                        <Tr key={index}>
                          <Td>{rs?.Country?.name}</Td>
                          <Td>{rs?.otp_cost?.toFixed(4)}</Td>
                          <Td>{rs?.utility_cost?.toFixed(4)}</Td>
                          <Td>{rs?.sender_id}</Td>
                          <Td>{new Date(rs?.updated_at).toLocaleDateString()}</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                  <Flex justifyContent="center" alignItems="center" >
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={100}
                      totalItemsCount={listCount}
                      pageRangeDisplayed={5}
                      onChange={onChangePaginate}
                      innerClass="pagination"
                      itemClass="page-item"
                      activeLinkClass="page-link active"
                      linkClass="page-link"
                      prevPageText="Previous"
                      nextPageText="Next"
                    />
                  </Flex>
                </TableContainer>
              </div>
            </TabPanel>
            <TabPanel className="customer_transaction_panel">
              {/* Table and filters for SMS Cost */}
              <HStack justifyContent="space-between" mb="25px">
                <Box>
                  <Text fontSize="32px" fontWeight="300" color="#000000">
                    IVR Cost Price List
                  </Text>
                </Box>
                <Box>
                  <HStack>
                    <Box>
                      <Menu>
                        <MenuButton
                          as={Button}
                          rightIcon={<Icon as={LuChevronDown} />}
                          className="menu-filter"
                        >
                          {selectedCountry.name || "Country"}
                        </MenuButton>
                        <MenuList>
                          <Box p="10px">
                            <Input
                              placeholder="Search country"
                              value={searchCountry}
                              onChange={(e) => meSearch("country", e)}
                            />
                          </Box>
                          <MenuItem onClick={() => handleSelect("country", "")}>
                            All Show
                          </MenuItem>
                          {filteredCountries?.slice(0, 10).map((rs, index) => (
                            <MenuItem
                              key={index}
                              onClick={() => handleSelect("country", rs)}
                            >
                              {rs.name}
                            </MenuItem>
                          ))}
                        </MenuList>
                      </Menu>
                    </Box>
                    <Box>
                      <Menu>
                        <MenuButton
                          as={Button}
                          rightIcon={<Icon as={LuChevronDown} />}
                          className="menu-filter"
                        >
                          {selectedOperator.name || "Operator"}
                        </MenuButton>
                        <MenuList>
                          <Box p="10px">
                            <Input
                              placeholder="Search operator"
                              value={searchOperator}
                              onChange={(e) => meSearch("operator", e)}
                            />
                          </Box>
                          <MenuItem onClick={() => handleSelect("operator", "")}>
                            All Show
                          </MenuItem>
                          {filteredOperator?.slice(0, 10).map((rs, index) => (
                            <MenuItem
                              key={index}
                              onClick={() => handleSelect("operator", rs)}
                            >
                              {rs.name}
                            </MenuItem>
                          ))}
                        </MenuList>
                      </Menu>
                    </Box>
                    <Box>
                      <Button className="filter-button" onClick={() => meCsv("ivr")}>
                        Download Price List
                      </Button>
                    </Box>
                    <Box>
                      <Menu>
                        <MenuButton as={Button} className="menu-filter-button" onClick={() => handleClick("ivr")}>
                          Import Updated Price List
                        </MenuButton>
                      </Menu>
                    </Box>
                  </HStack>
                </Box>
              </HStack>

              <div className="table_section">
                <TableContainer width="100%">
                  <Table
                    variant="simple"
                    width="100%"
                    borderWidth="1px"
                    borderColor="#CCCCCC"
                    borderStyle="solid"
                  >
                    <Thead>
                      <Tr>
                        <Th>Country</Th>
                        <Th>Operator</Th>
                        <Th>MCC</Th>
                        <Th>MNC</Th>
                        <Th>Prefix</Th>
                        <Th>Sender ID</Th>
                        <Th>SMS Cost</Th>
                        <Th>Last Updated</Th>
                      </Tr>
                    </Thead>

                    <Tbody fontSize="14px">
                      {list.map((rs, index) => (
                        <Tr key={index}>
                          <Td>{rs?.Operator?.Country?.name}</Td>
                          <Td>{rs?.Operator?.name}</Td>
                          <Td>{rs?.Operator?.mcc}</Td>
                          <Td>{rs?.Operator?.mnc}</Td>
                          <Td>{rs?.Operator?.prefix}</Td>
                          <Td>
                            {rs?.Operator?.sender_id === 0
                              ? "Default"
                              : rs?.Operator?.sender_id}
                          </Td>
                          <Td>{rs.sms_cost}</Td>
                          <Td>27/08/2024</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                  <Flex justifyContent="center" alignItems="center" >

                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={100}
                      totalItemsCount={listCount}
                      pageRangeDisplayed={100}
                      onChange={onChangePaginate}
                      innerClass="pagination"
                      itemClass="page-item"
                      activeLinkClass="page-link active"
                      linkClass="page-link"
                      prevPageText="Previous"
                      nextPageText="Next"
                    />
                  </Flex>
                </TableContainer>
              </div>
            </TabPanel>
            <TabPanel className="customer_transaction_panel">
              {/* Table and filters for SMS Cost */}
              <HStack justifyContent="space-between" mb="25px">
                <Box>
                  <Text fontSize="32px" fontWeight="300" color="#000000">
                    Other Channels Cost Price List
                  </Text>
                </Box>

              </HStack>

              <div className="table_section">
                <TableContainer width="100%">
                  <Table
                    variant="simple"
                    width="100%"
                    borderWidth="1px"
                    borderColor="#CCCCCC"
                    borderStyle="solid"
                  >
                    <Thead>
                      <Tr>
                        <Th>Channel Name</Th>
                        <Th>Price</Th>
                        <Th>Last Updated</Th>
                        <Th></Th>


                      </Tr>
                    </Thead>

                    <Tbody>
                      {Object.entries(channels).map(([channelId, channelData]) => (
                        <Tr key={channelId}>
                          <Td>{channelData.name}</Td>
                          <Td>
                            {channelData.price ?
                              <span
                                style={{ color: '#2563eb', cursor: 'pointer' }}
                                onClick={() => handleOpenModal(channelId, channelData, "price")}
                              >
                                {channelData.price.toFixed(2)}
                              </span>
                              :
                              <span
                                style={{ color: '#2563eb', cursor: 'pointer' }}
                                onClick={() => handleOpenModal(channelId, channelData, "price")}
                              >
                                Set Price
                              </span>
                            }
                          </Td>
                          <Td>{channelData.update_at ? channelData?.update_at : "-"}</Td>

                          <Td>
                            {channelData?.id === 'api_charges' && (
                              <span
                                style={{ color: '#2563eb', cursor: 'pointer' }}
                                onClick={() => handleOpenModal(channelId, channelData, "api_charges")}
                              >
                                {channelData.channel_in_use ?
                                  (() => {
                                    const selectedChannels = channelData.channel_in_use
                                      .filter(ch => ch.allow)
                                      .map(ch => channelOptions.find(opt => opt.id === ch.channel_id)?.name)
                                      .filter(Boolean);

                                    if (selectedChannels.length === 0) return 'No Channels Selected';
                                    if (selectedChannels.length <= 2) return selectedChannels.join(', ');

                                    return `${selectedChannels.slice(0, 2).join(', ')} +${selectedChannels.length - 2} more`;
                                  })()
                                  : 'Select Channels'
                                }
                              </span>
                            )}
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>


                </TableContainer>
              </div>
            </TabPanel>
          </TabPanels>
        </Tabs>
        <Modal isOpen={isModalOpen} size='xl' onClose={onModalClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              {modalType === 'channels' ? 'Select Channels' : 'Set Price'}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              {modalType === 'price' ? (
                <div className="grid gap-4 py-4">
                  <div className="flex items-center gap-4">
                    <label htmlFor="price" className="text-right">
                      Price:
                    </label>
                    <Input
                      id="price"
                      type="number"
                      step="0.0001"
                      value={newPrice}
                      onChange={(e) => setNewPrice(e.target.value)}
                      className="w-full"
                      placeholder="Enter price"
                    />
                  </div>
                </div>
              ) : (
                <div className="grid gap-4 py-4">
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {channelOptions.map((channel) => (
                      <Checkbox
                        key={channel.id}
                        isChecked={selectedChannel.includes(channel?.id)}
                        onChange={() => handleCheckboxChange(channel?.id)}
                      >
                        {channel.label}
                      </Checkbox>
                    ))}
                  </div>
                </div>
              )}
            </ModalBody>

            <ModalFooter>
              <Button variant="outline" mr={3} onClick={() => setIsModalOpen(false)}>
                Cancel
              </Button>
              <Button colorScheme="blue" onClick={handleSavePrice}>
                {modalType === 'channels' ? 'Update Channels' : 'Save Price'}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </div>
    </>
  );
}

export default List;
